import CategoryPage from "@/pages/category/components/CategoryPage";

export default function TvSeries() {
  return (
    <CategoryPage
      category="tvseries"
      categoryLabel="电视剧"
      path="/tvseries"
      h1="电视剧分类"
      description="可可影视电视剧频道汇聚国剧、海外剧与热门剧集，覆盖古装、悬疑、都市、年代等题材，可按类型、地区、年份与评分区间筛选，追更不迷路。"
      keywords="电视剧推荐,热播电视剧,电视剧分类,剧集评分,可可影视电视剧"
    />
  );
}